import api from "./api";
import { createDefaultConteudosData, normalizeConteudosData } from "../data";
const BASE = "/simuladores-conteudo";
const getSnapshotFromResponse = (response) => {
  const payload = response?.data?.data;
  return {
    initialized: Boolean(payload?.initialized),
    snapshot: normalizeConteudosData(
      payload?.snapshot || createDefaultConteudosData(),
    ),
  };
};
export async function fetchSimuladoresConteudoState() {
  const response = await api.get(BASE);
  return getSnapshotFromResponse(response);
}
export async function fetchSimuladoresConteudoAluno() {
  const response = await api.get(`${BASE}/aluno`);
  return getSnapshotFromResponse(response);
}
export async function fetchSimuladorCursoDetalhes(cursoId) {
  const response = await api.get(`${BASE}/curso-detalhes`, {
    params: {
      id: cursoId,
    },
  });
  const payload = response?.data?.data || {};
  return {
    modulos: Array.isArray(payload.modulos) ? payload.modulos : [],
    aulas: Array.isArray(payload.aulas) ? payload.aulas : [],
  };
}
export async function fetchSimuladorCursoEstrutura(cursoId) {
  const response = await api.get(`${BASE}/curso-estrutura`, {
    params: {
      id: cursoId,
    },
  });
  const payload = response?.data?.data || {};
  return {
    modulos: Array.isArray(payload.modulos) ? payload.modulos : [],
    aulas: Array.isArray(payload.aulas) ? payload.aulas : [],
  };
}
export async function fetchSimuladorAulaDetalhes(aulaId) {
  const response = await api.get(`${BASE}/aula-detalhes`, {
    params: {
      id: aulaId,
    },
  });
  return response?.data?.data || null;
}
export async function fetchSimuladoresConteudoInativos() {
  const response = await api.get(`${BASE}/inativos`);
  const payload = response?.data?.data || {};
  return {
    categorias: Array.isArray(payload?.categorias) ? payload.categorias : [],
    cursos: Array.isArray(payload?.cursos) ? payload.cursos : [],
    modulos: Array.isArray(payload?.modulos) ? payload.modulos : [],
    aulas: Array.isArray(payload?.aulas) ? payload.aulas : [],
  };
}
export async function fetchSimuladoresConteudoData() {
  const { snapshot } = await fetchSimuladoresConteudoState();
  return snapshot;
}
export async function fetchSimuladorCategorias() {
  const response = await api.get(`${BASE}/categorias`);
  return Array.isArray(response?.data?.data) ? response.data.data : [];
}
export async function fetchSimuladorCursosPaginated({
  page = 1,
  limit = 20,
  catId = "",
} = {}) {
  const params = {
    page,
    limit,
  };
  if (catId) params.cat_id = catId;
  const response = await api.get(`${BASE}/cursos`, {
    params,
  });
  const payload = response?.data?.data || {};
  return {
    items: Array.isArray(payload?.items) ? payload.items : [],
    pagination: {
      page: Number(payload?.pagination?.page || page),
      limit: Number(payload?.pagination?.limit || limit),
      total: Number(payload?.pagination?.total || 0),
      totalPages: Number(payload?.pagination?.total_pages || 1),
    },
  };
}
export async function createSimuladorCategoria(data) {
  const response = await api.post(`${BASE}/categorias`, data);
  return response?.data?.data || null;
}
export async function updateSimuladorCategoria(value, data) {
  const response = await api.put(
    `${BASE}/categorias?id=${encodeURIComponent(value)}`,
    data,
  );
  return response?.data?.data || null;
}
export async function deleteSimuladorCategoria(value) {
  await api.delete(`${BASE}/categorias?id=${encodeURIComponent(value)}`);
}
export async function restoreSimuladorCategoria(value) {
  await api.post(
    `${BASE}/categorias/restaurar?id=${encodeURIComponent(value)}`,
    {},
  );
}
export async function createSimuladorCurso(data) {
  const response = await api.post(`${BASE}/cursos`, data);
  return response?.data?.data || null;
}
export async function updateSimuladorCurso(value, data) {
  const response = await api.put(
    `${BASE}/cursos?id=${encodeURIComponent(value)}`,
    data,
  );
  return response?.data?.data || null;
}
export async function reorderSimuladorCurso({ sourceId, targetId }) {
  const response = await api.post(`${BASE}/cursos/reordenar`, {
    source_id: sourceId,
    target_id: targetId,
  });
  return response?.data?.data || null;
}
export async function deleteSimuladorCurso(value) {
  await api.delete(`${BASE}/cursos?id=${encodeURIComponent(value)}`);
}
export async function restoreSimuladorCurso(value) {
  await api.post(
    `${BASE}/cursos/restaurar?id=${encodeURIComponent(value)}`,
    {},
  );
}
export async function createSimuladorModulo(data) {
  const response = await api.post(`${BASE}/modulos`, data);
  return response?.data?.data || null;
}
export async function updateSimuladorModulo(value, data) {
  const response = await api.put(
    `${BASE}/modulos?id=${encodeURIComponent(value)}`,
    data,
  );
  return response?.data?.data || null;
}
export async function reorderSimuladorModulo({ sourceId, targetId }) {
  const response = await api.post(`${BASE}/modulos/reordenar`, {
    source_id: sourceId,
    target_id: targetId,
    sourceId,
    targetId,
  });
  return response?.data?.data || null;
}
export async function deleteSimuladorModulo(value) {
  await api.delete(`${BASE}/modulos?id=${encodeURIComponent(value)}`);
}
export async function restoreSimuladorModulo(value, data = {}) {
  await api.post(
    `${BASE}/modulos/restaurar?id=${encodeURIComponent(value)}`,
    data && typeof data === "object" ? data : {},
  );
}
export async function createSimuladorAula(data) {
  const response = await api.post(`${BASE}/aulas`, data);
  return response?.data?.data || null;
}
export async function updateSimuladorAula(value, data) {
  const response = await api.put(
    `${BASE}/aulas?id=${encodeURIComponent(value)}`,
    data,
  );
  return response?.data?.data || null;
}
export async function reorderSimuladorAula({
  sourceId,
  targetId,
  targetModuloId,
}) {
  const response = await api.post(`${BASE}/aulas/reordenar`, {
    source_id: sourceId,
    target_id: targetId,
    sourceId,
    targetId,
    target_modulo_id: targetModuloId,
    targetModuloId,
  });
  return response?.data?.data || null;
}
export async function deleteSimuladorAula(value) {
  await api.delete(`${BASE}/aulas?id=${encodeURIComponent(value)}`);
}
export async function restoreSimuladorAula(value, data = {}) {
  await api.post(
    `${BASE}/aulas/restaurar?id=${encodeURIComponent(value)}`,
    data && typeof data === "object" ? data : {},
  );
}
export async function deleteSimuladorBloco(value) {
  await api.delete(`${BASE}/blocos?id=${encodeURIComponent(value)}`);
}
export async function saveSimuladoresConteudoStructure(data) {
  const payload = normalizeConteudosData(data);
  await api.put(`${BASE}/estrutura`, {
    categorias: payload.categorias,
    cursos: payload.cursos,
    modulos: payload.modulos,
    aulas: payload.aulas,
  });
}
export async function fetchSimuladoresConteudoErros() {
  const response = await api.get(`${BASE}/erros`);
  return Array.isArray(response?.data?.data) ? response.data.data : [];
}
export async function saveSimuladoresConteudoErrors(erros) {
  await api.put(`${BASE}/erros`, {
    erros: Array.isArray(erros) ? erros : [],
  });
}
export async function saveSimuladoresConteudoProgress(progresso) {
  await api.post(`${BASE}/progresso`, {
    progresso: progresso && typeof progresso === "object" ? progresso : {},
  });
}
export async function uploadSimuladorImage(file) {
  const payload = new FormData();
  payload.append("file", file);
  const response = await api.post(`${BASE}/imagem`, payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response?.data?.data || null;
}
export async function uploadSimuladorEmbedHtml(file) {
  const payload = new FormData();
  payload.append("file", file);
  const response = await api.post(`${BASE}/embed-html`, payload, {
    headers: {
      "Content-Type": "multipart/form-data",
    },
  });
  return response?.data?.data || null;
}
export async function reportSimuladorErro(erro) {
  await api.post(`${BASE}/erros`, erro);
}
export { BASE };
